export class fxView {
}
fxView.STORE_MODULE_NAME = 'fxView';



//////////////////
// WEBPACK FOOTER
// ./src/plugins/fxView/lib/fxView.cls.ts
// module id = null
// module chunks = 